import type { ISettingsOption } from '@/interfaces'
import { AppVersion, UserSettings } from '@/interfaces'

const SettingsOptions: ISettingsOption[] = [
  {
    title: 'Specialty',
    field_name: 'Specialty',
    app_versions: [AppVersion.STANDALONE, AppVersion.INTEGRATED],
  },
  {
    title: 'Password',
    field_name: 'Password',
    app_versions: [AppVersion.STANDALONE, AppVersion.INTEGRATED],
  },
  {
    title: 'Patient Weight and Height Units',
    field_name: 'Patient Weight and Height Units',
    app_versions: [AppVersion.STANDALONE, AppVersion.INTEGRATED],
  },
  {
    title: 'Patient Consent Recording Prompt',
    field_name: UserSettings.HIDE_RECORDING_PERMISSION_PROMPT,
    app_versions: [AppVersion.STANDALONE, AppVersion.INTEGRATED],
  },
  {
    title: 'HPI Merging',
    field_name: UserSettings.HPI_MERGING,
    app_versions: [AppVersion.INTEGRATED],
  },
  {
    title: 'Default Note Generation Mode',
    field_name: UserSettings.DEFAULT_NOTE_GENERATION_MODE,
    app_versions: [AppVersion.STANDALONE, AppVersion.INTEGRATED],
  },
  {
    title: 'Default Visit Filter Options',
    field_name: UserSettings.DEFAULT_VISIT_FILTER_OPTIONS,
    app_versions: [AppVersion.STANDALONE, AppVersion.INTEGRATED],
  },
]

export default SettingsOptions
